import { Cell } from '@wix/design-system'
import React, { FC, memo, useCallback } from 'react'

import type { Content } from '../Content'
import { Radio } from '../Radio'

type Option = Content['role']['options'][number]

type MembersOptionProps = {
  option: Option
  checked: boolean
  onClick?: (option: Option) => void
}

export const MembersOption: FC<MembersOptionProps> = memo(({ option, checked, onClick }) => {
  const handleClick = useCallback(() => onClick?.(option), [onClick, option])
  const span = 4

  return (
    <Cell span={span} key={option.optionKey}>
      <Radio checked={checked} value={option.optionKey} label={option.title} onClick={handleClick} />
    </Cell>
  )
})
